module.exports = __webpack_public_path__ + "img/default.910bc8c2.png";